import React, { useState } from "react";
import { fmtCurrency } from "../../utils/helpers";
import "./styles.css";
import Radios from "../../components/Radios";

function getPrice(data, qty) {
	let price = 0;
	data.forEach((item) => {
		if (item.qty === qty) {
			price = item.price;
		}
	});
	return price;
}

const WdC = ({ total, update }) => {
	const [names, setNames] = useState({});

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
		update(name, value);
		total(getPrice(cookbooks, value));
	};

	const cookbooks = [
		{
			qty: 1,
			name: "One copy of Well Done! plus shipping",
			price: 4495,
		},
		{
			qty: 2,
			name: "Two copies of Well Done! plus shipping",
			price: 8665,
		},
		{
			qty: 3,
			name: "Three copies of Well Done! plus shipping",
			price: 12810,
		},
		{
			qty: 4,
			name: "Four copies of Well Done! plus shipping",
			price: 16980,
		},
		{
			qty: 5,
			name: "Five copies of Well Done! plus shipping",
			price: 21125,
		},
	];

	return (
		<div>
			<Radios
				name="copies"
				hdg="Select Number of Cookbooks"
				req={true}
				update={handleUpdate}
				data={cookbooks.map((item) => {
					return {
						value: item.qty,
						label: `${item.name} - ${fmtCurrency(item.price)}`,
						checked: names.copies === item.qty ? true : false,
					};
				})}
			/>
			<p>
				If you’re interesting in purchasing more copies of Well Done! please{" "}
				<a href="/contact/">contact us</a> or call us at 561.630.0025.
			</p>
		</div>
	);
};

export default WdC;
